import { render, staticRenderFns } from "./ServerViewer.vue?vue&type=template&id=37793cc8"
import script from "./ServerViewer.vue?vue&type=script&lang=js"
export * from "./ServerViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports